<template>
  <FormSelect
    :value="value"
    @input="updateValue"
    :optionsPromise="taxRatePromise"
    :field="field"
    :placeholder="placeholder"
    :note="note"
  />
</template>

<script>
import _ from 'lodash'

export default {
  name: 'TaxRateSelect',
  model: {
    event: 'update'
  },
  props: {
    value: [Number, String],
    field: String,
    placeholder: String,
    note: String,
    allowNone: Boolean
  },
  data() {
    return {
      taxRatePromise: this.getTaxRatePromise(),
    }
  },
  methods: {
    getTaxRatePromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.adminService.getTaxRateList()
        .then(response => {
          let rateList = response.data

          let defaultIndex = 0
          if(this.$store.state.account.salesTaxRate.id)
            defaultIndex = rateList.findIndex(rate => rate.id == this.$store.state.account.salesTaxRate.id)

          var rateOptions = rateList.map((rate, index) => {
            return { name: `${rate.displayName}`, value: rate.id, isDefault: index == defaultIndex }
          })

          return resolve(_.concat(_.compact(this.allowNone ? [{ value: null, name: 'None' }] : null), rateOptions))
        })
        .catch(err => { return reject(err) })
      })
    },
    updateValue(value) {
      this.$emit('update', value)
    }

  }
}
</script>